import { createClient } from '@sanity/client';
import Config from '@Config';
import dayjs from 'dayjs';

export const client = createClient({
  ...Config.sanity,
  useCdn: true,
  apiVersion: dayjs().format('YYYY-MM-DD'),
});

export default client;
